// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__vgLhm","Status-active":"links_Status-active__OGso1","Status-inactive":"links_Status-inactive__ERzw3","balance":"links_balance__s6Vwk"};